export default "https://cdn-static.gokick.com/assets/4894ba43e4289cab16e653fbabc6637092de6282/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";